import { Link } from "react-router-dom";
import { useContent } from "../content-context";
import { Eyebrow, Reveal } from "./Reveal";

function Card({ exp, index }) {
  const wide = exp.span === "lg:col-span-12";
  if (exp.noOverlay) {
    return (
      <Reveal className={`${exp.span} row-span-1`} delay={(index % 4) * 0.07}>
        <Link
          to={exp.to}
          data-testid={`experience-card-${index + 1}`}
          aria-label={`${exp.title} — ${exp.copy}`}
          className="group relative block h-72 overflow-hidden md:h-80 lg:h-full lg:min-h-[320px]"
        >
          <img
            src={exp.src}
            alt={exp.alt}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
          />
        </Link>
      </Reveal>
    );
  }
  return (
    <Reveal
      className={`${exp.span} ${wide ? "" : "row-span-1"}`}
      delay={(index % 4) * 0.07}
    >
      {exp.to ? (
        <Link
          to={exp.to}
          data-testid={`experience-card-${index + 1}`}
          aria-label={`${exp.title} — ${exp.copy}`}
          className={`group relative block h-72 overflow-hidden md:h-80 lg:h-full lg:min-h-[320px] ${wide ? "lg:h-[440px]" : ""}`}
        >
          <Experiences_media exp={exp} wide={wide} index={index} />
        </Link>
      ) : (
        <article
          data-testid={`experience-card-${index + 1}`}
          className={`group relative h-72 overflow-hidden md:h-80 lg:h-full lg:min-h-[320px] ${wide ? "lg:h-[440px]" : ""}`}
        >
          <Experiences_media exp={exp} wide={wide} index={index} />
        </article>
      )}
    </Reveal>
  );
}

function Experiences_media({ exp, wide, index }) {
  return (
    <>
      <img
        src={exp.src}
        alt={exp.alt}
        loading="lazy"
        style={{ objectPosition: exp.pos || "center" }}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/25 to-navy/5 transition-opacity duration-700 group-hover:from-navy/95" />
      <span className="absolute right-6 top-6 font-display text-lg italic text-gold-2/90">
        0{index + 1}
      </span>
      <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
        <span className="block h-px w-10 bg-gold transition-all duration-700 group-hover:w-20" />
        <h3
          className={`mt-4 font-display font-medium text-ivory ${wide ? "text-3xl md:text-4xl" : "text-2xl md:text-[1.7rem]"}`}
          data-testid={`experience-title-${index + 1}`}
        >
          {exp.title}
        </h3>
        <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-ivory/75">
          {exp.copy}
        </p>
      </div>
    </>
  );
}

export default function Experiences() {
  const { experiences } = useContent();
  return (
    <section id="experiences" data-testid="experiences-section" className="bg-navy py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="mb-14 flex flex-col gap-6 md:mb-20 md:flex-row md:items-end md:justify-between">
          <div>
            <Reveal>
              <Eyebrow light>Island Experiences</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                className="mt-6 font-display text-4xl font-medium leading-[1.05] text-ivory md:text-6xl"
                data-testid="experiences-heading"
              >
                Days shaped by <em className="text-gold-2">sea, fire and sky</em>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm font-light leading-relaxed text-coastal">
              Adventure and restoration in equal measure — every experience below is yours, exclusively.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6" data-testid="experiences-grid">
          {experiences.map((exp, i) => (
            <Card key={exp.title} exp={exp} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
